"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const recoil_1 = require("recoil");
const settingPCCStates_1 = require("./settingPCCStates");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
function default_1({ user_id, setDeliverySettingData, settingPCCForm, }) {
    const { handleSubmit, reset, formState: { isDirty }, } = settingPCCForm;
    const resetIsPCCValid = (0, recoil_1.useResetRecoilState)(settingPCCStates_1.isPCCValidState);
    const resetIsChangePCC = (0, recoil_1.useResetRecoilState)(settingPCCStates_1.isChangePCCState);
    const resetPCCInput = () => {
        resetIsPCCValid();
        resetIsChangePCC();
    };
    const submitRef = (0, react_1.useRef)(false);
    const setIsSubmitPCCPending = (0, recoil_1.useSetRecoilState)(settingPCCStates_1.isSubmitPCCPendingState);
    return handleSubmit((inputData) => __awaiter(this, void 0, void 0, function* () {
        if (!isDirty) {
            resetPCCInput();
        }
        else if (!submitRef.current) {
            submitRef.current = true;
            setIsSubmitPCCPending(true);
            const { second_customvalue } = inputData;
            const data = { second_customvalue };
            const onSuccess = () => {
                setDeliverySettingData(prev => (Object.assign(Object.assign({}, prev), { second_customvalue })));
                resetPCCInput();
                reset({ second_customvalue });
            };
            const onFinally = () => {
                submitRef.current = false;
                setIsSubmitPCCPending(false);
            };
            yield (0, api_1.patchData)(`/api/v1/members/${user_id}`, data)
                .then(onSuccess)
                .catch(err => {
                var _a, _b, _c, _d;
                const errorStatus = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
                const errorCode = (_d = (_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
                if (errorStatus === 403)
                    (0, errors_1.handle403Error)(err);
                else
                    alert((0, errors_1.commonErrorMsg)(errorCode || errorStatus));
            })
                .finally(onFinally);
        }
    }));
}
exports.default = default_1;
